module.exports = "/wp-content/plugins/farmacy/assets/js/images/search-icon-e7c9eb45e0d4dbc409a1a11334d963f9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/header-control-bar/search-button/img/search-icon.png
 ** module id = 561
 ** module chunks = 1 27 28 133
 **/